export const appendSafeChargeScript = () => {
    let safechargeScript = document.getElementById('safecharge-pay-script')
    const head = document.getElementsByTagName('head')[0]

    return new Promise((resolve, reject) => {
        if (!safechargeScript) {
            const script = document.createElement('script')
            script.id = 'safecharge-pay-script'
            script.type = 'text/javascript'
            script.src = `https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js`
            script.async = true
            script.onload = () => {
                resolve(window.SafeCharge)
            }
            head.appendChild(script)
        } else {
            resolve(window.SafeCharge)
        }
    })
    
}